import React from 'react';
import FileBase64 from 'react-file-base64';
import 'whatwg-fetch';
import file_upload_rules from '../../data/file-upload-rules';

import ModalConfirm from '../components/modal/modalConfirm';

import ringAnim from '../../images/anim/ring.svg';
import SubNavBar from '../components/SubNavBar';
import SubNavBarActions from 'src/scenes/appOrderForm/components/SubNavBarActions';
import withAuth from 'src/hoc/withAuth';

const apiDealShow = '/api/deal/show/';
const apiAddOrderForm = '/api/stepCommercial/addOrderFormToFileForProd';
const apiOrderFormDocument = '/__api__/api/stepCommercial/orderform/';
const apiRemoveOrderForm = '/api/stepCommercial/removeOrderFormToFileForProd/';

class AppOrderForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      entity: undefined,
      isModalAddOpen: false,
      files: [],
      savedOrderForm: undefined,
      isModalDeleteOpen: false,
      uploadState: undefined,
      proposal: undefined,
      customer: undefined,
      docPrices: true,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.openDocument = this.openDocument.bind(this);
    this.openModalDeleteFile = this.openModalDeleteFile.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
    this.toggleDoc = this.toggleDoc.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  // For base64 Input
  getFiles(files) {
    let fileValid = true;
    if (files.file.size > file_upload_rules.sizeLimit) {
      // file too big
      this.props.openToast(false, 'La taille maximale autorisée est de 20 Mo');
      fileValid = false;
    } else if (file_upload_rules.acceptedTypes.indexOf(files.file.type) === -1) {
      // file type not accepted
      this.props.openToast(false, 'format non autorisé');
      fileValid = false;
    }

    if (fileValid) {
      this.setState({ files: files });
    }
  }

  openDocument(docType) {
    if (this.props.match.params.id) {
      let url = apiOrderFormDocument;

      let form = document.createElement('form');
      form.method = 'POST';
      form.action = url;
      form.target = '_blank';

      let json = {
        deal: {
          id: this.props.match.params.id,
        },
        docPrices: this.state.docPrices,
        docType,
      };

      let input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'orderformEntry';
      input.value = JSON.stringify(json);
      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
    }
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      // check if id supplied in the route
      const paramsID = this.props.match.params.id;

      let queryURL = apiDealShow;
      let graphQL =
        '{ deal(id:' +
        paramsID +
        '){ id, name, dateCreate, domain{ id }, desiredClotureDate, ' +
        'stepCommercial{ id, fileForProd{ orderForm{ id, name } }, intermediateStageNumber, proposition{ id, pdc, modelType }, commercialEmployee{ user{ id, username } } }, ' +
        'stepProd{ id, intermediateStageNumber } ' +
        '} }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then((data) => {
          if (data['data']['deal']) {
            let orderForm = data['data']['deal']['stepCommercial']['fileForProd']['orderForm']
              ? data['data']['deal']['stepCommercial']['fileForProd']['orderForm']
              : null;
            this.setState({
              entity: data['data']['deal'],
              savedOrderForm: orderForm,
            });
          } else {
            this.props.openToast(false, 'Affaire non-trouvée');
          }
        });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.componentDidMount();
    }
  }

  render() {
    const { savedOrderForm, entity = {} } = this.state;

    const domainId = (entity.domain || {}).id;
    const modelType = (((entity.stepCommercial || {}).proposition || {}).modelType || '').toLowerCase();

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar
          actionButton={
            <SubNavBarActions
              isInformatique={2 === domainId || 'informatique' === modelType}
              docPrices={this.state.docPrices}
              openDocument={this.openDocument}
              toggleDoc={this.toggleDoc}
            />
          }
          goBack={this.props.history.goBack}
          title='Bon de Commande'
        />

        <div id='appViewContent'>
          {!savedOrderForm && <p>Une fois le BDC signé par le client, veuillez l'ajouter ci-dessous.</p>}
          <div className='alignHorizontal'>
            {savedOrderForm ? (
              <div className='alignHorizontal'>
                <a target='_blank' href={'/' + savedOrderForm.name}>
                  <span className='icon icon-attachment'>
                    {savedOrderForm.name.split('/')[savedOrderForm.name.split('/').length - 1]}
                  </span>
                </a>
                <button
                  onClick={() => this.openModalDeleteFile(savedOrderForm.id)}
                  type='button'
                  className='btn btn-sm btn-outline-success'
                >
                  <span className='icon icon-cross'></span>
                </button>
              </div>
            ) : (
              <FileBase64
                className='btn btn-sm btn-outline-success'
                multiple={false}
                onDone={this.getFiles.bind(this)}
              />
            )}
            {this.state.uploadState == 'onGoing' && (
              <div className='alignHorizontal'>
                <img src={ringAnim} />
              </div>
            )}
            {this.state.uploadState == 'done' && <span className='icon icon-check'>Sauvegardé</span>}
            {this.state.uploadState == 'failed' && <span className='icon icon-cross'>Erreur</span>}
          </div>
        </div>
        <div className='appViewTotal flexEnd appViewFixed'>
          <div className='alignHorizontal'>
            <button onClick={this.handleSubmit} type='button' className='btn btn-sm btn-success'>
              <span className='icon icon-document'>Sauvegarder</span>
            </button>
          </div>
        </div>

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalDeleteOpen}
          onSubmit={this.deleteFile}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        />
      </div>
    );
  }

  openModalDeleteFile(id) {
    if (this.state.savedOrderForm) {
      let modalText = {
        title: 'Suppression BDC',
        message: 'Vous allez supprimer ce bon de commande',
      };
      this.props.toggleBlackOut();
      this.setState({
        textModal: modalText,
        fileToDeleteId: id,
        isModalDeleteOpen: true,
      });
    }
  }

  toggleDoc() {
    let value = this.state.docPrices ? false : true;
    this.setState({
      docPrices: value,
    });
  }

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({ isModalDeleteOpen: false });
  }

  deleteFile() {
    if (this.state.savedOrderForm) {
      this.setState({ uploadState: 'onGoing' });
      let json = {
        orderform: {
          id: this.state.savedOrderForm.id,
        },
      };
      let queryURL = apiRemoveOrderForm;
      queryURL += encodeURIComponent(JSON.stringify(json));
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'DELETE',
        })
        .then((resp) => resp.json())
        .then((data) => {
          if (data.isValid) {
            this.componentDidMount();
            this.setState({ uploadState: undefined });
            this.props.openToast(true, 'Vous venez de supprimer le BDC');
          } else {
            this.setState({ uploadState: 'failed' });
            this.props.openToast(false, 'Erreur suppression BDC. Veuillez réessayer');
          }
        })
        .catch(() => {
          this.setState({ uploadState: 'failed' });
          this.props.openToast(false, 'Suppression impossible');
        });
    }
  }

  handleSubmit() {
    this.postOrderForm(); // handle the Toast message
  }

  postOrderForm() {
    this.setState({ uploadState: 'onGoing' });
    let payload = {
      deal: {
        id: this.props.match.params.id,
      },
      orderForm: {
        typeOfFile: this.state.files.type.split('/')[1],
      },
    };

    let data = 'metadata=' + encodeURIComponent(JSON.stringify(payload));
    data += '&';
    data += 'base64=' + encodeURIComponent(this.state.files.base64.split('base64,')[1]);
    this.props
      .authFetch(apiAddOrderForm, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.isValid) {
          this.componentDidMount();
          this.setState({ uploadState: 'done' });
          this.props.openToast(true, 'Vous venez de sauvegarder le BDC');
          //this.props.history.push("/dashboard/deal/"+this.props.match.params.id);
        } else {
          this.setState({ uploadState: 'failed' });
          this.props.openToast(false, 'Erreur sauvegarde BDC. Veuillez réessayer');
        }
      })
      .catch(() => {
        this.setState({ uploadState: 'failed' });
      });
  }
}

export default withAuth(AppOrderForm);
